const stats = [
  {
    icon: 'ri-shield-check-fill',
    value: '10,000+',
    label: 'Assets Protected',
  },
  {
    icon: 'ri-building-2-fill',
    value: '5,000+',
    label: 'Entities Structured',
  },
  {
    icon: 'ri-money-dollar-circle-fill',
    value: '$2B+',
    label: 'In Wealth Shielded',
  },
  {
    icon: 'ri-award-fill',
    value: '20+ Yrs',
    label: 'Legal Experience',
  },
  {
    icon: 'ri-star-fill',
    value: '4.9 / 5',
    label: 'Client Rating',
  },
];

export default function TrustBar() {
  return (
    <section className="relative z-10 bg-[#111111] border-y border-white/10">
      <div className="max-w-6xl mx-auto px-4 py-4">
        {/* Stats row — grid on mobile, flex row on md+ */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:flex md:items-center md:justify-center md:divide-x md:divide-white/10">
          {stats.map((stat, i) => (
            <div
              key={stat.label}
              className={`flex items-center gap-2 px-4 py-3 md:px-5 md:py-2 group cursor-default transition-transform duration-200 hover:scale-105
                ${i === 4 ? 'col-span-2 sm:col-span-1 justify-center sm:justify-start' : ''}
                ${i % 2 === 0 && i !== 4 ? 'border-r border-white/10 md:border-r-0' : ''}
                ${i < 4 ? 'border-b border-white/10 sm:border-b-0 md:border-b-0' : ''}
                ${i < 2 ? 'sm:border-b sm:border-white/10' : ''}
              `}
            >
              <div className="w-7 h-7 flex items-center justify-center text-[#dc2626] group-hover:text-red-400 text-base shrink-0 transition-colors duration-200">
                <i className={stat.icon}></i>
              </div>
              <div>
                <div className="text-white group-hover:text-red-100 font-black text-sm leading-tight tracking-tight whitespace-nowrap transition-colors duration-200">
                  {stat.value}
                </div>
                <div className="text-gray-400 group-hover:text-gray-300 text-[10px] font-medium uppercase tracking-widest whitespace-nowrap transition-colors duration-200">
                  {stat.label}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Featured In media logos bar */}
        <div className="mt-6 pt-6 border-t border-white/10">
          <p className="text-center text-gray-500 text-[10px] font-semibold uppercase tracking-[0.2em] mb-5">
            As Featured In
          </p>
          <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-4 sm:gap-x-8">
            <span className="text-gray-400 hover:text-gray-200 transition-colors duration-200 font-black text-lg tracking-tight italic select-none whitespace-nowrap">
              Forbes
            </span>
            <span className="text-gray-400 hover:text-gray-200 transition-colors duration-200 font-semibold text-sm tracking-tight select-none whitespace-nowrap flex items-center gap-1">
              <span className="inline-block w-3 h-3 bg-gray-400 rounded-sm text-[8px] flex items-center justify-center leading-none font-black text-[#111]">G</span>
              BankingRates
            </span>
            <span className="text-gray-400 hover:text-gray-200 transition-colors duration-200 font-black text-lg tracking-tight select-none whitespace-nowrap">
              Bloomberg
            </span>
            <span className="text-gray-400 hover:text-gray-200 transition-colors duration-200 font-black text-xl tracking-widest select-none whitespace-nowrap">
              FOX
            </span>
            <span className="text-gray-400 hover:text-gray-200 transition-colors duration-200 font-black text-lg tracking-widest select-none whitespace-nowrap flex items-center gap-1">
              <i className="ri-broadcast-fill text-base"></i>
              NBC
            </span>
            <span className="text-gray-400 hover:text-gray-200 transition-colors duration-200 font-semibold text-sm tracking-wide select-none whitespace-nowrap">
              Entrepreneur
            </span>
            <span className="text-gray-400 hover:text-gray-200 transition-colors duration-200 font-black text-base tracking-tight select-none whitespace-nowrap">
              yahoo!<span className="text-xs font-semibold ml-0.5">finance</span>
            </span>
            <span className="text-gray-400 hover:text-gray-200 transition-colors duration-200 font-black text-lg tracking-widest select-none whitespace-nowrap flex items-center gap-1">
              <i className="ri-broadcast-fill text-base"></i>
              CNBC
            </span>
            <span className="text-gray-400 hover:text-gray-200 transition-colors duration-200 font-black text-lg tracking-widest select-none whitespace-nowrap">
              msn
            </span>
            <span className="text-gray-400 hover:text-gray-200 transition-colors duration-200 font-serif font-bold text-sm tracking-wide select-none whitespace-nowrap flex items-center gap-1">
              <i className="ri-graduation-cap-fill text-base"></i>
              Wharton
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
